import React, { useEffect, useState } from 'react'
import HeaderPage from '../components/homePage/HeaderPage'
import FooterPage from '../components/homePage/FooterPage'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
import HeaderUser from '../components/homePage/HeaderUser';




function PrivacyPolicy() {
 
  const { userDetailLogin } = useSelector((state) => state.auth);
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  const [policy, setPolicy] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchPrivacyPolicy = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/front/privacy-policy`);
      const result = await res.json();
      
      if (result.status && result.data) {
            setPolicy(result.data.policy);
        }
    } catch (error) {
      console.error("Privacy policy fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  return (
    
    <>
    { userDetailLogin?._id ? <HeaderUser /> : <HeaderPage /> }
    <>
  <section className="inrbnr">
    <div className="container-fluid con-flu-padd">
      <div className="inrbnrContent">
        <h1>Privacy Policy</h1>
        <ul className="inrbrnNav">
          <li>
            <Link to={userDetailLogin?._id ? '/dashboard':'/'}>
              <img src="assets/img/icons/home.png" alt="home icon" />
            </Link>
            <img src="assets/img/icons/arrows.png" alt="arrows icons" />
          </li>
          <li>
            <Link to="#">Privacy Policy</Link>
          </li>
        </ul>
      </div>
    </div>
  </section>
  {/* Section End */}
  <section>
    <div className="register-sec">
      <div className="container-fluid con-flu-padd term-page">
        <div className='mx-2 py-5'>
          {loading ? (
                <p>Loading...</p>
            ) : (
                <div
                dangerouslySetInnerHTML={{ __html: policy }}
                />
            )}
        </div>
      </div>
    </div>
  </section>
</>



    <FooterPage /> 

     
    </>
    
  )
}

export default PrivacyPolicy
